import React from 'react'

import './SpinningCirclesLoader.css'

interface SpinningCirclesLoaderProps {
  size?: number
  className?: string
  colors?: {
    circle1?: string // bottom
    circle2?: string // top
    circle3?: string // right
    circle4?: string // left
  }
  speed?: 'slow' | 'normal' | 'fast'
}

const SpinningCirclesLoader: React.FC<SpinningCirclesLoaderProps> = ({
  className = '',
  colors = {
    circle1: '#0a0ae9', // bottom - dark blue
    circle2: '#ccd0ff', // top - light blue
    circle3: '#3f4ef3', // right - medium blue
    circle4: '#5764ff', // left - blue
  },
}) => {
  return (
    <div className={`spinner-container ${className}`}>
      <svg
        className={`spinner`}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Circle 1 (bottom) */}
        <circle
          className={`circle circle-1`}
          cx="50"
          cy="50"
          r="8"
          fill={colors.circle1}
        />

        {/* Circle 2 (top) */}
        <circle
          className={`circle circle-2`}
          cx="50"
          cy="50"
          r="8"
          fill={colors.circle2}
        />

        {/* Circle 3 (right) */}
        <circle
          className={`circle circle-3`}
          cx="50"
          cy="50"
          r="8"
          fill={colors.circle3}
        />

        {/* Circle 4 (left) */}
        <circle
          className={`circle circle-4`}
          cx="50"
          cy="50"
          r="8"
          fill={colors.circle4}
        />
      </svg>
    </div>
  )
}

export default SpinningCirclesLoader
